/**
 * Catalog plan candidate limits (mirrors stripe-webhook/catalogPlans.ts).
 */
export const PLAN_MAX_CANDIDATES = {
  essential: 100,
  pro: 5000,
  'essential-and-voice': 100,
  'pro-and-voice': 5000,
  trial: 25,
};

export const TRIAL_VOICE_AI_MINUTES = 30;

export const getPlanMaxCandidates = (planId) => {
  const key = String(planId ?? '').trim().toLowerCase();
  return PLAN_MAX_CANDIDATES[key] ?? PLAN_MAX_CANDIDATES.essential;
};

export const getCandidatesOverLimitCount = (candidateCount, maxCandidates) => {
  const count = Number(candidateCount) || 0;
  const max = Number(maxCandidates) || 0;
  return Math.max(0, count - max);
};

export const isSubscriptionOverLimit = (profile) => (
  profile?.subscription_status === 'over_limit'
);
